import React from 'react';
import PropTypes from 'prop-types';

import AraraIconButton from '../AraraIconButton';


const FilterButton = ({ onClick, className }) => (
  <AraraIconButton
    onClick={onClick}
    iconName="button-filter"
    hoveredIconName="button-filter-hover"
    className={className}
  />
);


FilterButton.defaultProps = {
  className: '',
};

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default FilterButton;
